import { createApp } from 'vue';
import ElevationTextResolver from '../components/elevation_text_resolver';

document.addEventListener('DOMContentLoaded', () => {
  const app = createApp({
    components: { ElevationTextResolver }
  });
  app.mount('#elevation_gain_text');
});
